import Vue from 'vue'
import Router from 'vue-router'
// import routes from 'vue-auto-routing'
import localstore from 'store'
import cookies from 'js-cookie'
import { createRouterLayout } from 'vue-router-layout'
import { routes } from 'vue-router/auto-routes'
import store from '@/store'
import TokenizedAccess from '@/pages/tokenized-access/_token.vue'
import qs from 'qs'
Vue.use(Router)

const RouterLayout = createRouterLayout((layout) => {
  if (layout === 'default') {
    return import('./layouts/default.vue')
  }
  return import('@/layouts/clean.vue')
  // return import('@/layouts/' + layout + '.vue')
})

const router = new Router({
  mode: 'history',
  saveScrollPosition: true,
  routes: [
    {
      name: 'tokenized-access',
      path: '/tokenized-access/:token?',
      component: TokenizedAccess
    },
    {
      path: '/',
      component: RouterLayout,
      children: routes
    },
    {
      path: '*',
      component: RouterLayout,
      children: [
        {
          name: 'page-404',
          path: '',
          component: () => import('@/components/NotFound.vue')
        }
      ]
    }
  ],
  // set custom query resolver
  parseQuery(query) {
    return qs.parse(query)
  },
  stringifyQuery(query) {
    var result = qs.stringify(query)

    return result ? '?' + result : ''
  }
})

router.beforeEach((to, from, next) => {
  if (store?.getters['unsavedChanges']) {
    let options = {
      title: 'Unsaved changes',
      text: `There are unsaved changes. Are you sure you want to navigate away?`,
      showCancelButton: false,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#33d',
      confirmButtonText: 'Yes, leave',
      cancelButtonText: 'Stay',
      buttonsStyling: true
    }
    Vue.prototype
      .$confirm(options.text, options.title, 'warning', options)
      .then((result) => {
        store.dispatch('setUnsavedChanges', false)
        handleRouteGuards(to, from, next)
      })
      .catch((error) => {
        // canceled, stay on page
        return next(false)
      })
    // confirmed reset unsaved changes and continue
  } else {
    handleRouteGuards(to, from, next)
  }
})

const handleRouteGuards = (to, from, next) => {
  const user = localstore.get('ews_user', {})
  const current = localstore.get('ews_current_station', {})
  if (to.matched.some((record) => record.path == '/stagehand') && user.access && !user.access.stagehand.includes(current.station)) {
    next('/')
  } else if (to.matched.some((record) => record.path == '/admin') && !user.access?.admin) {
    next('/')
  } else if (to.matched.some((record) => record.name !== 'tokenized-access') && current.station && !to.query?.station) {
    // make sure station query parameter persists route changes
    try {
      let updatedNext = {
        ...to,
        query: {
          ...to.query,
          station: current.station
        }
      }
      next(updatedNext)
    } catch (error) {
      // canceled, stay on page
      return next(false)
    }
  } else {
    next()
  }
}

export default router
